const mockTableData = {
  lad: {
    'ICC' : 0.959,
    '95CI' : '0.914 ~ 0.981'
  },
  lcx: {
    'ICC' : 0.980,
    '95CI' : '0.976 ~ 0.995'
  },
  rca: {
    'ICC' : 0.981,
    '95CI' : '0.981 ~ 0.992'
  },
};

export default mockTableData;
